import SeasonPassDayPassSummary from './SeasonPassDayPassSummary';

export default SeasonPassDayPassSummary;
